<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import FooterWrapper from "@/components/FooterWrapper";

export default {
  // Included components
  components: {
    FooterWrapper,
  },

  data() {
    return {
      // Whether the attempt to verify email failed
      failed: false,
    };
  },

  computed: {
    // Mapped vuex state
    ...mapState(["teams"]),
    ...mapGetters(["authenticated"]),
  },

  // On initial load, attempt to verify the user's email
  async created() {
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;

    // If currently authenticated to an account, then display error and return
    if (this.authenticated) {
      this.pushToast({
        title: "Error",
        message:
          "Please sign out of the current account before verifying the email for another account.",
        variant: "danger",
      });

      await this.$router.push("/");
      return;
    }

    // Verify email
    const success = await this.verify({ email: this.email, token: this.token });

    // If successfully verified, then:
    if (success) {
      // Load user information
      await Promise.all([
        this.getUser(),
        this.getTeams(),
        this.getPermissions(),
        this.getAccountRoles(),
      ]);

      // Get the first team to set active
      const firstTeam = Object.keys(this.teams)[0];

      // Set first team to active
      this.setActiveTeamId(firstTeam);

      // redirect
      await this.$router.push("/");
    } else {
      this.failed = true;
    }
  },

  methods: {
    // Send a new email confirmation token
    async resend() {
      let success = await this.resendEmailConfirmation({ email: this.email });
      if (success) {
        await this.$router.push("/sign-up/success");
      }
    },

    // Mapped vuex state
    ...mapMutations(["setActiveTeamId", "pushToast"]),
    ...mapActions([
      "verify",
      "getUser",
      "getTeams",
      "resendEmailConfirmation",
      "getAccountRoles",
      "getPermissions",
    ]),
  },
};
</script>

<template>
  <FooterWrapper>
    <b-container fluid>
      <b-row align-h="center">
        <b-col lg="9" xl="8" class="py-5">
          <h1 class="mb-3">Sign Up</h1>
          <b-card class="text-center py-5" v-if="failed">
            <b-card-title>Could not verify email</b-card-title>
            <b-card-text>Confirmation link is invalid or expired</b-card-text>
            <b-button variant="primary" @click="resend">
              Resend Confirmation
            </b-button>
          </b-card>
          <b-card class="text-center py-5" v-else>
            <b-card-title>Verifying Email...</b-card-title>
            <b-card-text>You will be redirected shortly</b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </FooterWrapper>
</template>
